import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgReward(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0496 5.90475C11.3502 4.98605 12.6498 4.98605 12.9504 5.90475L14.1246 9.49342H17.9049C18.8753 9.49342 19.2769 10.7366 18.49 11.3044L15.4377 13.5066L16.6073 17.0812C16.9083 18.0012 15.8568 18.7695 15.0718 18.2031L12 15.9868L8.92824 18.2031C8.14316 18.7695 7.09168 18.0012 7.39272 17.0812L8.56231 13.5066L5.51002 11.3044C4.72306 10.7366 5.12471 9.49342 6.09512 9.49342H9.87539L11.0496 5.90475Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);

var RewardSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { RewardSolid as default };
